'use strict';

var React = require('react');
var index = require('./index-fccd5f88.js');
var Icons = require('./Icons-46f5553f.js');
var injectGlobalCss = require('./injectGlobalCss-bc8cf911.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var css = "/*Hearted Animation*/\n@keyframes ActionIcon_module_grow__25865d0c {\n  0% {\n    transform: scale(1);\n  }\n  100% {\n    transform: scale(1.2);\n  }\n}\n@keyframes ActionIcon_module_shrink__25865d0c {\n  0% {\n    transform: scale(1.2);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n\n.ActionIcon_module_visuallyHidden__25865d0c {\n  position: absolute !important;\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important;\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n}\n\n.ActionIcon_module_youtubeVideo__25865d0c {\n  width: 100%;\n  height: auto;\n  aspect-ratio: 16/9;\n  display: block;\n}\n\n/*Heart Action*/\n.ActionIcon_module_HeartItem__25865d0c {\n  animation: ActionIcon_module_shrink__25865d0c 0.3s 2;\n  transition: all 0.3s ease-in;\n  width: 44px;\n  height: 44px;\n  display: block;\n  background-color: Transparent;\n  transition: all 0.2s ease-in-out;\n  z-index: 2;\n  border: none;\n  cursor: pointer;\n}\n.ActionIcon_module_HeartItem__25865d0c .ActionIcon_module_Label__25865d0c:not(:focus):not(:active) {\n  clip: rect(0 0 0 0);\n  clip-path: inset(100%);\n  height: 1px;\n  overflow: hidden;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n}\n.ActionIcon_module_HeartItem__25865d0c:hover {\n  transform: scale(1.1);\n}\n\n.ActionIcon_module_HeartedItem__25865d0c {\n  animation: ActionIcon_module_grow__25865d0c 0.3s 2;\n  transition: all 0.3s ease-in;\n  width: 44px;\n  height: 44px;\n  display: block;\n  background-color: Transparent;\n  z-index: 2;\n  border: none;\n  cursor: pointer;\n}\n.ActionIcon_module_HeartedItem__25865d0c svg {\n  height: 100%;\n}\n.ActionIcon_module_HeartedItem__25865d0c:hover {\n  transform: scale(1.1);\n}\n.ActionIcon_module_HeartedItem__25865d0c:focus {\n  outline: none;\n}\n.ActionIcon_module_HeartedItem__25865d0c:focus-visible {\n  border-radius: 48px;\n  background-color: #ffffff;\n  box-shadow: inset 0px 0px 0px 3px #7f5f9c, 0px 0px 0px 2px #ffffff, 1px 8px 16px rgba(25, 25, 25, 0.2);\n}\n.ActionIcon_module_HeartedItem__25865d0c:focus-visible svg {\n  fill: #444F6B !important;\n}\n.ActionIcon_module_HeartedItem__25865d0c .ActionIcon_module_Label__25865d0c:not(:focus):not(:active) {\n  clip: rect(0 0 0 0);\n  clip-path: inset(100%);\n  height: 1px;\n  overflow: hidden;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n}";
injectGlobalCss.injectCss(css, "/opt/atlassian/pipelines/agent/build/src/stories/components/Molecules/ActionIcon/ActionIcon.module.scss");
var modules_6e9ae1bf = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1080px)","uiBreakWideScreenMin":"strip-units(1920px)","visuallyHidden":"ActionIcon_module_visuallyHidden__25865d0c","youtubeVideo":"ActionIcon_module_youtubeVideo__25865d0c","HeartItem":"ActionIcon_module_HeartItem__25865d0c","shrink":"ActionIcon_module_shrink__25865d0c","Label":"ActionIcon_module_Label__25865d0c","HeartedItem":"ActionIcon_module_HeartedItem__25865d0c","grow":"ActionIcon_module_grow__25865d0c"};

function ActionIcon(_ref) {
  var color = _ref.color,
    activeColor = _ref.activeColor,
    light = _ref.light,
    label = _ref.label,
    ariaLabel = _ref.ariaLabel,
    iconDefault = _ref.iconDefault,
    iconActive = _ref.iconActive,
    onClick = _ref.onClick,
    isActive = _ref.isActive,
    iconHSize = _ref.iconHSize,
    iconWSize = _ref.iconWSize,
    extraClass = _ref.extraClass;
  if (light) {
    var iconColor = "#ffffff";
    var shadow = true;
  } else {
    var iconColor = color;
  }
  return /*#__PURE__*/React__default["default"].createElement("button", {
    "aria-label": ariaLabel,
    onClick: onClick,
    className: [isActive ? modules_6e9ae1bf.HeartItem : modules_6e9ae1bf.HeartedItem, extraClass].join(' ')
  }, /*#__PURE__*/React__default["default"].createElement(Icons.Icon, {
    iconColor: !isActive ? iconColor : activeColor,
    iconHSize: iconHSize || 32,
    iconName: !isActive ? iconDefault : iconActive,
    iconWSize: iconWSize || 32,
    iconShadow: shadow
  }), /*#__PURE__*/React__default["default"].createElement("span", {
    className: modules_6e9ae1bf.Label
  }, ariaLabel ? ariaLabel : label));
}

//export default HeartItemAction;
ActionIcon.propTypes = {
  activeColor: index.propTypes.exports.string,
  iconWSize: index.propTypes.exports.number,
  iconHSize: index.propTypes.exports.number,
  color: index.propTypes.exports.string,
  light: index.propTypes.exports.bool,
  label: index.propTypes.exports.string,
  ariaLabel: index.propTypes.exports.string.isRequired,
  iconDefault: index.propTypes.exports.string,
  iconActive: index.propTypes.exports.string,
  onClick: index.propTypes.exports.func,
  isActive: index.propTypes.exports.bool,
  extraClass: index.propTypes.exports.string
};

exports.ActionIcon = ActionIcon;
